import styled from 'styled-components';

import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';

export const StyledDialog = withStyles(() => ({
  paper: {
    margin: 18,
  },
  paperWidthSm: {
    width: '100%',
    maxWidth: 580,
  },
  paperScrollPaper: {
    flexDirection: 'row',
  },
}))(Dialog);

export const Content = styled.section`
  position: relative;
  width: 100%;
  height: auto;
  padding: 20px 18px 24px 18px;

  h2 {text-transform: initial;}

  p {
    margin-top: 24px;
  }

  a {
    text-decoration: underline;
  }

  .MuiButtonBase-root {
    display: flex;
    width: 100%;
    margin: 20px 0;
    text-decoration: none;
  }
`;
